import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownModule} from "primeng/dropdown";
import {NgIf} from "@angular/common";
import {TagModule} from "primeng/tag";
import {Components, DropdownItem, Options} from "../../../interfaces/personas-proyecto.interface";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {PrimeNgModule} from "../../../prime-ng/prime-ng.module";
import {TenenciaEnum} from "../../../../users/interfaces/proyecto.interface";
import {DraftProjectService} from "../../../../users/proyectos/services/draft-project.service";

@Component({
  selector: 'app-components-pasos',
  standalone: true,
    imports: [
        DropdownModule,
        NgIf,
        TagModule,
        ReactiveFormsModule,
        PrimeNgModule
    ],
  templateUrl: './components-pasos.component.html',
  styleUrl: './components-pasos.component.scss'
})
export class ComponentsPasosComponent implements OnInit{

    @Input()component!:Components;
    @Input() form!: FormGroup;
    @Input() step!: number;
    @Output() onEmitterSelectDropdown= new EventEmitter<{dropDownItem:DropdownItem, tituloFileUpload:string, informacion:string, componetKey: string}>
    @Output() onEmitterInputNumber = new EventEmitter<number>
    dropDownSeleted: DropdownItem | null = null
    showCargarEscritura: boolean = false
    buttonPropietario: Boolean = false;
    openDialog: boolean = false;
    tituloFileUpload:string='';
    informacion:string='';
    public constructor(protected draftProjectService: DraftProjectService) {
    }

    ngOnInit(): void {
        console.log("ComponentsPasosComponent ngOnInit")
        this.validInputNumberForm();
    }

    onKeyUp(event: any) {
        if (event) {
            let valorNumerico = this.form.get(this.component.key)?.value;
            this.onEmitterInputNumber.emit(valorNumerico);
        }
    }

    setDropdown(options: Options | null) {
        if (!options) {
            this.showCargarEscritura = false;
            this.dropDownSeleted = null;
            this.buttonPropietario = false;
            this.onEmitterSelectDropdown.emit({dropDownItem:this.dropDownSeleted!,tituloFileUpload:this.tituloFileUpload!,informacion:this.informacion!, componetKey:this.component.key!});
        } else {
            let dropdownItem:DropdownItem={key:options.key==null?'0':options.key!, idRequisito:options.idRequisito!, descripcion:options.value,
                estado:options.estado!};
            this.showCargarEscritura = (dropdownItem.key === TenenciaEnum.Propietario);
            this.dropDownSeleted = dropdownItem;
            this.tituloFileUpload=options.tituloFile!;
            this.informacion=options.tituloInfo!;
            this.buttonPropietario = true;
            this.onEmitterSelectDropdown.emit({dropDownItem:this.dropDownSeleted,tituloFileUpload:this.tituloFileUpload,informacion:this.informacion,componetKey:this.component.key!});
        }
    }

    get isValid() {
        return this.form.controls[this.component.key].valid;
    }
    private validInputNumberForm() {
        if (this.draftProjectService.draftProject().montoInversion == null) {
            this.onEmitterInputNumber.emit(0);
        }
        if (this.draftProjectService.draftProject().montoInversion.toString() == "") {
            this.onEmitterInputNumber.emit(0);
        }
        if (this.form) {
            // Establecer el valor  de la signal a el campo 'montoInversion' del formulario
            this.form.patchValue({
                montoInversion: this.draftProjectService.draftProject().montoInversion
            });
        }
    }

}
